var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6V2H11V3.5H9C8.73486 3.50026 8.48066 3.60571 8.29319 3.79319C8.10571 3.98066 8.00026 4.23486 8 4.5V7.5H5V6H1V10H5V8.5H8V11.5C8.00026 11.7651 8.10571 12.0193 8.29319 12.2068C8.48066 12.3943 8.73486 12.4997 9 12.5H11V14H15V10H11V11.5H9V4.5H11V6H15ZM4 9H2V7H4V9ZM12 11H14V13H12V11ZM12 3H14V5H12V3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnections);
export default __webpack_public_path__ + "static/media/connections.8fb4ca388dbed7bb6b01ae0848933968.svg";
export { ForwardRef as ReactComponent };